import React from 'react'
import LetterAvatar from './LetterAvatar'

const LetterAvatarReplacement = () => {
    return (
        <div className="col-xxl-6">
            <div className="card p-0 overflow-hidden position-relative radius-12">
                <div className="card-header py-16 px-24 bg-base border border-end-0 border-start-0 border-top-0">
                    <h6 className="text-lg mb-0">Letter Avatar Replacement Examples</h6>
                </div>
                <div className="card-body p-24">
                    <p className="text-muted mb-3">Replace image avatars with letter avatars:</p>

                    <div className="d-flex align-items-center flex-wrap gap-3">
                        {/* Before: Image avatar */}
                        <div className="text-center">
                            <img
                                src="assets/images/avatar/avatar1.png"
                                className="w-40-px h-40-px rounded-circle object-fit-cover"
                                alt="Avatar"
                            />
                            <small className="d-block mt-1 text-muted">Before: Image</small>
                        </div>

                        {/* After: Letter avatar */}
                        <div className="text-center">
                            <LetterAvatar letter="J" size="40px" />
                            <small className="d-block mt-1 text-muted">After: Letter</small>
                        </div>
                    </div>

                    <hr className="my-4" />

                    <h6 className="mb-3">Different Sizes:</h6>
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <LetterAvatar letter="A" size="24px" />
                        <LetterAvatar letter="B" size="32px" />
                        <LetterAvatar letter="C" size="40px" />
                        <LetterAvatar letter="D" size="44px" />
                        <LetterAvatar letter="E" size="56px" />
                        <LetterAvatar letter="F" size="64px" />
                        <LetterAvatar letter="G" size="72px" />
                        <LetterAvatar letter="H" size="80px" />
                    </div>

                    <hr className="my-4" />

                    <h6 className="mb-3">Usage in Components:</h6>
                    <div className="d-flex flex-column gap-2">
                        <div className="d-flex align-items-center gap-3 p-2 border rounded">
                            <LetterAvatar letter="John" size="32px" />
                            <span>User list item</span>
                        </div>
                        <div className="d-flex align-items-center gap-3 p-2 border rounded">
                            <LetterAvatar letter="Comment" size="40px" />
                            <span>Comment section</span>
                        </div>
                        <div className="d-flex align-items-center gap-3 p-2 border rounded">
                            <LetterAvatar letter="Profile" size="56px" />
                            <span>Profile card</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LetterAvatarReplacement 